module.exports = __webpack_public_path__ + "img/circle_spinner.65147b74.png";